import { Link } from "react-router-dom";
import { articles } from "@/mocks/fancha";

export default function LatestSection() {
  return (
    <section id="latest" className="scroll-mt-20 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-accent-600">LATEST</p>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              最新深扒观察
            </h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600">
              从道歉话术到滤镜逻辑，从心理学到理性围观——我们把吃瓜这件事，讲成一篇篇值得收藏的观察笔记。
            </p>
          </div>
          <Link
            to="/about"
            className="whitespace-nowrap inline-flex items-center gap-1.5 rounded-full border border-background-200 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            了解我们 <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="mt-8 space-y-4">
          {articles.map((a, i) => (
            <Link
              key={a.id}
              to={`/article/${a.id}`}
              className="group grid grid-cols-1 gap-4 overflow-hidden rounded-2xl border border-background-200/70 bg-background-50 p-4 transition-shadow hover:shadow-lift md:grid-cols-12 md:items-center md:p-5"
            >
              <div className="relative aspect-[16/9] overflow-hidden rounded-xl md:col-span-3 md:aspect-[4/3]">
                <img
                  src={a.cover}
                  alt={a.title}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.05]"
                />
              </div>
              <div className="md:col-span-8">
                <div className="flex flex-wrap items-center gap-2 text-xs text-foreground-500">
                  <span className="font-heading text-sm font-bold text-background-300">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <span className="rounded-full bg-accent-100 px-2 py-0.5 font-semibold text-accent-800">{a.category}</span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-time-line" /> {a.minutes} 分钟
                  </span>
                </div>
                <h3 className="mt-2 font-heading text-lg font-bold leading-snug text-foreground-950 group-hover:text-primary-700 md:text-xl">
                  {a.title}
                </h3>
                <p className="mt-2 hidden text-sm leading-6 text-foreground-600 sm:block">{a.summary}</p>
              </div>
              <div className="flex items-center justify-between text-xs text-foreground-500 md:col-span-1 md:flex-col md:items-end md:gap-2">
                <span className="whitespace-nowrap">{a.date}</span>
                <span className="whitespace-nowrap flex items-center gap-1">
                  <i className="ri-eye-line" /> {a.views}
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}